import Loader, { Spinner } from "components/DesignSystem/Loader/loader";
import { TickSlim } from "components/icons/TickSlim";

export const IncorporationQuestionSaveStatus = ({
  isSaving,
  isAnswered,
}: {
  isSaving: boolean;
  isAnswered: boolean;
}) => {
  if (isSaving) {
    return (
      <span className="t-flex t-shrink-0 t-items-center t-gap-1 t-text-body-sm t-text-text-30">
        <Loader size="small" />
        Saving...
      </span>
    );
  }

  if (isAnswered) {
    return (
      <span className="t-flex t-shrink-0 t-items-center t-gap-1 t-text-body-sm-italic t-italic t-text-text-30">
        <TickSlim />
        Saved
      </span>
    );
  }

  return null;
};
